import React from "react";
import { useNavigate } from "react-router-dom";

const GererMonCompte = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-100 min-h-screen flex justify-center items-center">
      <div className="max-w-4xl w-full p-6 bg-white shadow-lg rounded-lg relative">
        {/* Flèche retour */}
        <button onClick={() => navigate(-1)} className="absolute top-4 left-4 text-gray-600 hover:text-black">
          ⬅ Retour
        </button>

        <h1 className="text-3xl font-bold text-gray-800 mb-4 text-center">Gérer mon compte</h1>
        <p className="text-gray-600 mb-6 text-center">Modifiez les paramètres de votre compte.</p>

        <div className="space-y-4">
          <button className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 flex items-center justify-center">
            🔐 Modifier mon mot de passe
          </button>

          <button className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700 flex items-center justify-center">
            ⚠ Supprimer mon compte
          </button>
        </div>
      </div>
    </div>
  );
};

export default GererMonCompte;
